import { c as _c } from "react/compiler-runtime";
export default function WedriveEcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8.93 10H9a5.07 5.07 0 005-5 5 5 0 10-5 5h-.07zm0-8a3 3 0 012.17.91A2.89 2.89 0 0112 5a3.06 3.06 0 01-3 3 3 3 0 01-2.09-.9A3 3 0 016 4.93 3 3 0 019 2h-.07zm6 32.37V48a3 3 0 01-3 3H6a3 3 0 01-3-3V34.8a5.72 5.72 0 00-.19-1.91A2.74 2.74 0 010 30V16a4 4 0 014-4h9.44a5.36 5.36 0 00-.9 2H4a2 2 0 00-2 2v14c0 .55.17.89 1 .89 2 0 2 2.74 2 3.9V48a1 1 0 001 1h6a1 1 0 001-1V32.5a4.75 4.75 0 002 1.87h-.07zM18 5a5 5 0 115.07 5A5.06 5.06 0 0118 5zm5.67 36a13 13 0 004 9.34 4.22 4.22 0 01-2 .64h-5.75A2.82 2.82 0 0117 47.84V34.28A5 5 0 0017 33a3 3 0 01-3-2.9V15.82c0-3.18 2.06-3.82 3.79-3.82h9.88c2.67 0 4.33 1.44 4.33 3.82v13A13 13 0 0023.67 41zm50-10.69a10.83 10.83 0 00-1.49.11l-1.08-4.58-2.36-10a1 1 0 00-1-.77h-5.45a1 1 0 100 2H67l.81 3.43H46.93l-.8-3.5h4.18a1 1 0 100-2h-7.88a1 1 0 100 2h1.65l1.08 4.61L40.45 31a10.84 10.84 0 106.86 11.11h3.43a1 1 0 00.72-.32l18.1-14 .71 3a10.82 10.82 0 103.44-.57l-.04.09zM36.52 50a8.84 8.84 0 113-17.14l-3.93 7.85a1 1 0 00.89 1.45h8.82A8.85 8.85 0 0136.52 50zm1.62-9.84l3.2-6.41a8.85 8.85 0 014 6.42l-7.2-.01zm9.18 0a10.84 10.84 0 00-5.08-8.21l3.63-7.26 3.62 15.48-2.17-.01zm4-.76l-4-16.94h20.97l.76 3.24-17.73 13.7zM73.71 50a8.84 8.84 0 01-3-17.16l2 8.55a1 1 0 001 .77h.23a1 1 0 00.75-1.2l-2-8.55a8.84 8.84 0 111 17.62l.02-.03z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} fill="currentColor" viewBox="0 0 85 52" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}